<!--
 * @Description: 官网通用模板
 * @Author: youme
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2020-06-15 10:30:37
 * @LastEditTime: 2024-05-27 13:29:23
-->
<template>
  <div>
    <Head />
    <div class="person-body">
      <div class="show-body" :style="{backgroundColor: color}">
        <slot />
      </div>
      <div class="hidden-lg-and-up">
        <div class="foot-up">
          <div class="container">©大连豪森智源数据有限公司 <a target="_blank" href="http://beian.miit.gov.cn/">辽ICP备18010847号-2</a></div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from '@/components/Foot'
import Head from '@/components/Head'

export default {
  name: 'Container',
  components: { Foot, Head },
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
  .foot-up {
    position: fixed;
    bottom: 70px;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 10px;
    color: #fff;
    width: 100%;
    height: 34px;
    background-color: #3e3892;
    line-height: 10px;
    z-index: 2000;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
  .person-body {
    padding-top: 50px;
    padding-bottom: 70px;
  }
  .show-body {
    min-height: calc(100vh - 152px);
  }
}
</style>
